var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallEnd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 18,
    viewBox: "0 0 43 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6438 11.608L42.223 13.8116C41.8299 15.875 39.9004 17.2605 37.7159 17.0501L33.3681 16.6294C31.4726 16.4466 29.8576 15.0994 29.3753 13.3016L28.0344 8.29726C26.0475 7.48338 23.8588 7.11151 21.4681 7.18163C19.1659 7.23115 16.8969 7.74202 14.7956 8.68401L13.9648 13.3696C13.6481 15.1461 12.184 16.47 10.3268 16.657L6.00451 17.0905C3.84763 17.3073 1.77788 15.9345 1.16588 13.8818L0.507132 11.6781C-0.145243 9.48513 0.437007 7.17738 2.04138 5.61976C5.82388 1.94351 12.1351 0.0990081 20.9688 0.0862581C29.8151 0.0756331 36.3198 1.90951 40.4848 5.58576C42.2379 7.13276 43.056 9.42351 42.6416 11.608H42.6438Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallEnd);
export default __webpack_public_path__ + "static/media/call-end.e79489b19d9050ec204fa1e9920a9a03.svg";
export { ForwardRef as ReactComponent };